import React from 'react'
import './Spinner.css'
export default function Spinner() {
    return (
        <div class="loadingio-spinner-rolling-od70bu4ftmr"><div class="ldio-ae39cstvvm4">
<div></div>
</div></div>
    )
}
